import { useState, useEffect } from 'react';
import data from './data';
import Mapa from './Mapa'

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

function App() {
  const { height, width } = useWindowDimensions()
  
  return (
    <div className="App">
      <Mapa
        data={data.map((d,i)=>{
          d['index'] = i
          return d
        })}
        size={{
          width: width - 65,
          height: height - 65,
          margin: { top: 30, right: 30, bottom: 30, left: 30 }
        }}
        colorPaises="#D4D9D0"
        colorFondo="#F2F2F0"
      />
    </div>
  );
}

export default App;
